import React from "react";
import styled from "styled-components";
import { STANDARD, ROLE_STYLES } from "src/constants/roles";
import pluralize from "pluralize";
import { customNames } from "src/utils/helpers";

const Button = styled.button`
    background: ${ p => p.background };
    color: ${ p => p.color };
    min-width: 100px;
    width: 170px !important;
    height: 32px;
    padding: 0.6em 0.7em;
    border-radius: 7px;
    border: none;
    box-shadow: none;
    cursor: none;
    pointer-events: none;
    display: ${ p => p.isFromModal && "block" };
    font-size: ${ p => p.fontSize && p.fontSize + " !important" };
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 600;
`;

const Permission = (props) => {
    const roleStyles = ROLE_STYLES;
    const hasLeadershipRole = props.hasLeadershipRole;
    const fontSize = "12px";
    const isFromModal = props.isFromModal; //rendering From UserPermissionModal
    
    const handleStyles = (key) => {
        return props.role ? roleStyles[props.role][key] : roleStyles[0][key];
    };

    const renderBtnText = (name) => props.role === STANDARD ? `${name} (${ props.isClient ? `${pluralize.singular(customNames.clients)}` : `${pluralize.singular(customNames.employees)}` })` : name;


    return (
        <>
            <Button 
                background={handleStyles("background")} 
                color={handleStyles("color")} 
                hasLeadershipRole={hasLeadershipRole}
                isFromModal={isFromModal}
                fontSize={fontSize}
            >
                { renderBtnText(handleStyles("name")) }
            </Button>
        </>
    );
};

export default Permission;